export default {

    indexDateMaskTypes:     { method: 'get',    url: 'date_mask_types' },
    storeDateMaskType:      { method: 'post',   url: 'date_mask_types' },
    updateDateMaskType:     { method: 'put',    url: 'date_mask_types/{id}'},
    destroyDateMaskType:    { method: 'delete', url: 'date_mask_types/{id}'},

}